import { getWirepasGatewaysAdmin, getWirepasAnchors } from '@/crud/wirepas-location'

// Both endpoints are paginated, so this needs take=1000 to get every gateway/anchor, not one page.
async function fetchGatewaysAndAnchors(): Promise<{ gateways: any[]; allAnchors: any[] }> {
  const [gwRes, anchorRes] = await Promise.all([
    getWirepasGatewaysAdmin({ take: 1000 }),
    getWirepasAnchors({ take: 1000, includeTagsHeard: false }),
  ])
  return { gateways: gwRes.data?.result || [], allAnchors: anchorRes.data?.result || [] }
}

// Anchors whose gateway is assigned to the given scheme location.
export async function fetchAnchorsForLocation(locationId: number | null | undefined): Promise<any[]> {
  if (!locationId) return []
  try {
    const { gateways, allAnchors } = await fetchGatewaysAndAnchors()
    const gwIds = new Set(
      gateways.filter((g: any) => g.assignedLocationId === locationId).map((g: any) => g.gwId)
    )
    return allAnchors.filter((a: any) => (a.gateways || []).some((gw: string) => gwIds.has(gw)))
  } catch {
    return []
  }
}

// Same as fetchAnchorsForLocation, but keyed by AssetGroup id instead of AssetGroupLocation id
// -- used where only the group is known yet (e.g. picking a location before its scheme exists).
export async function fetchAnchorsForGroup(groupId: number | null | undefined): Promise<any[]> {
  if (!groupId) return []
  try {
    const { gateways, allAnchors } = await fetchGatewaysAndAnchors()
    const gwIds = new Set(
      gateways.filter((g: any) => g.assetGroupId === groupId).map((g: any) => g.gwId)
    )
    return allAnchors.filter((a: any) => (a.gateways || []).some((gw: string) => gwIds.has(gw)))
  } catch {
    return []
  }
}
